var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "c69311da-1c63-4e5e-ba83-584ad1b71aea"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "a74f8be8-2f63-47c4-b6eb-943aef7d36b5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1 0 0 1.1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6 0 0 1.6 -76.84 0.14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-201.61, -249.64)",
    d: "M 0 249.6 C 0 259.1 7.7 266.8 17.2 266.8 L 344.8 266.8 L 280.90000000000003 330.6 C 274.20000000000005 337.3 274.20000000000005 348.20000000000005 280.90000000000003 354.90000000000003 C 284.20000000000005 358.20000000000005 288.6 359.90000000000003 293.00000000000006 359.90000000000003 C 297.4000000000001 359.90000000000003 301.80000000000007 358.20000000000005 305.1000000000001 354.90000000000003 L 398.20000000000005 261.80000000000007 C 404.90000000000003 255.10000000000008 404.90000000000003 244.20000000000007 398.20000000000005 237.50000000000006 L 305.1 144.40000000000006 C 298.40000000000003 137.70000000000007 287.5 137.70000000000007 280.8 144.40000000000006 C 274.1 151.10000000000005 274.1 162.00000000000006 280.8 168.70000000000007 L 344.6 232.50000000000006 L 17.2 232.50000000000006 C 7.7 232.5 0 240.1 0 249.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6 0 0 1.6 8.01 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-254.55, -249.55)",
    d: "M 396.4 494.2 C 453.09999999999997 494.2 499.09999999999997 448.09999999999997 499.09999999999997 391.4 L 499.09999999999997 107.7 C 499.1 51 453 4.9 396.4 4.9 L 112.7 4.9 C 56 4.9 10 51 10 107.7 L 10 166 C 10 175.5 17.7 183.1 27.1 183.1 C 36.6 183.1 44.3 175.4 44.3 166 L 44.3 107.7 C 44.3 70 75 39.2 112.7 39.2 L 396.4 39.2 C 434.09999999999997 39.2 464.79999999999995 69.9 464.79999999999995 107.7 L 464.79999999999995 391.4 C 464.79999999999995 429.09999999999997 434.09999999999997 459.9 396.4 459.9 L 112.7 459.9 C 75 459.9 44.3 429.2 44.3 391.4 L 44.3 333.79999999999995 C 44.3 324.29999999999995 36.599999999999994 316.59999999999997 27.099999999999998 316.59999999999997 C 17.6 316.59999999999997 10 324.3 10 333.8 L 10 391.40000000000003 C 10 448.1 56.1 494.20000000000005 112.7 494.20000000000005 L 396.4 494.20000000000005 L 396.4 494.2 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.568b34c2fc6b288b8e86b6f9d66ddff1.svg";
export { ForwardRef as ReactComponent };